module.exports = __webpack_public_path__ + "img/navbar-toggler-icon.7a34f17b.svg";